import { useState, type InputHTMLAttributes, type ReactElement } from 'react';
import { IconOjo, IconOjoCerrado } from './iconos';

/**
 * LA CONTRASEÑA, CON SU OJO. Escribirla a ciegas en un móvil es la forma más
 * segura de equivocarse: el botón la enseña o la oculta. Es un botón de verdad
 * (`aria-pressed`) y no cambia el foco, así que se puede comprobar y seguir
 * escribiendo. Recibe lo mismo que un `<input>`.
 */
export function CampoContrasena(
  props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>,
): ReactElement {
  const [visible, setVisible] = useState(false);
  return (
    <div className="contrasena">
      <input
        {...props}
        className={`input contrasena__campo ${props.className ?? ''}`.trim()}
        type={visible ? 'text' : 'password'}
      />
      <button
        type="button"
        className="contrasena__ojo"
        aria-label={visible ? 'Ocultar la contraseña' : 'Mostrar la contraseña'}
        aria-pressed={visible}
        disabled={props.disabled}
        // Sin robar el foco al campo: se mira y se sigue escribiendo.
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => setVisible((v) => !v)}
      >
        {visible ? <IconOjoCerrado size={20} /> : <IconOjo size={20} />}
      </button>
    </div>
  );
}
